import React from "react";
import { isDate } from '../../../../helpers/isDate';
import TableComponent, { TableOp } from "../../../../components/table/TableOps";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Http from "../../../../Http";
import { Slide, Snackbar } from "@material-ui/core";
import ACCESS from "../../../../ACCESS";

class FacturasClientes extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `envios-factura/filter-envio-facturas/${this.props.idFolio}`,
        deleteUrl: "envios-factura/delete-factura",
        deleteField: "folio",
        // modUrl: "/Cobranza/FacturaCliente/:id?",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio", id: "folio" },
          { label: "Cliente", id: "cliente" },
          { label: "Fecha", id: "createdAt" },
        ],
        [{ id: 'delete', icon: 'delete', access: [ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO] }]
      )
    );
    this.table();
  }

  componentDidUpdate(prevprops) {
    if (this.props.add) {
      const { tableData } = this.state;
      const prevRows = tableData.rows;
      tableData.rows = [];
      for (const factura of this.props.facturas) {
        for (let prop in factura) {
					if (prop !== 'id' && prop !== 'id_unidad_transporte' && isDate(factura[prop])) {
						// console.log(`Campo ${prop} es de tipo fecha`)
						factura[prop] = moment(factura[prop]).format('D/M/YYYY HH:mm');
					}
				}
        tableData.rows.push({ ...factura });
      }
      tableData.rows.push(...prevRows);
      if (this.deleteRow) {
        tableData.rows = tableData.rows.filter(r => r.id !== this.deleteRow.id)
      }
      this.rpp = 15;
      this.setState({
        tableData: {
          ...tableData,
          rows: tableData.rows,
          total: tableData.rows.length,
          rpp: 15,
        },
      });
      this.props.onAdd();
    }
  }

	dialogClose = async (op) => {
		this.setState({ dialog: { show: false }, loading: true });
    this.deleteRow.id_cyc_envio = this.props.idFolio;
		if (op === 1) {
      if (this.deleteRow.nueva) {
        this.deleteRow.delete = true;
        this.props.onDelete(this.deleteRow);
      } else {
        let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
        if (!Res.error) {
          this.table();
          this.setState({
            sbMsg: `Se elimino la factura`,
            sbOpen: true,
          });
        } else {
          this.setState({
            sbMsg: `Ocurrio un error: ${Res.errMsg}`,
            sbOpen: true,
          });
        }
      }
		}
		this.setState({ loading: false });
	}

  render() {
    const { sbMsg, sbOpen } = this.state;
    return (
      <div>
        <this.TableRender />
        <Snackbar
            open={sbOpen}
            onClose={() => {
              this.setState({ sbOpen: false });
            }}
            TransitionComponent={Slide}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{sbMsg}</span>}
          />
      </div>
    );
  }
}

export default withRouter(FacturasClientes);
